// @ts-check
import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
import VueAnalytics from "vue-analytics";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filters";
import { GA } from "./config";
import "@/assets/scss/main.scss";

const isProd = process.env.NODE_ENV === "production";

// Config
Vue.config.productionTip = false;
Vue.config.performance = !isProd;
// Vue.config.errorHandler = (error, vm, info) => {
//   errorLogger.log(error, vm, info)
// }
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  Vue.prototype.$log = console.log;
}

Vue.use(VueCompositionApi);
Vue.use(VueAnalytics, {
  id: GA,
  router,
  autoTracking: {
    exception: true,
  },
  debug: {
    enabled: !isProd,
    // trace: true, // Very verbose console logging
    sendHitTask: isProd,
  },
});

for (var filter in filters) {
  if (filters.hasOwnProperty(filter)) {
    Vue.filter(filter, filters[filter]);
  }
}

const globals = require.context("@/components/global", false, /.*\.vue$/);
globals.keys().forEach((fileName) => {
  const config = globals(fileName);
  const name = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
  Vue.component(name, config.default || config);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
